export function safeJson<T extends any>(jsonStr: string): T {
    try {
        return JSON.parse(jsonStr) as T;
    } catch (error) {
        // TODO @涛峰 需要加error上报
        return {} as T;
    }
}
